import { FormikErrors, FormikTouched, FormikHelpers } from "formik"

export enum LANGS {
  KA = "ka",
  EN = "en",
}

export enum IRoles {
  QAPP_ADMIN = "QappAdmin",
  QAPP_MANAGER = "QappManager",
  WASHER_ADMIN = "CarWashAdmin",
  WASHER_MANAGER = "CarWashManager",
  WASHER = "Washer",
  CASHIER = "Cashier",
}

export interface IRoute {
  path: string
  element: React.ReactElement | null
  isPrivate: boolean
  allowedRoles: IRoles[]
}

export interface IFile {
  name: string
  size: number
  type: string
  webkitRelativePath: string
  lastModified: number
  lastModifiedDate: Date
}

export type Omitted = "disabled" | "required" | "readOnly" | "size"

export interface ISelectOption {
  label: string
  value: string
}
export interface IPagination {
  itemCount: number
  skip: number
  take: number
}

export interface IBaseResponse {
  status: number
  statusDescription: string
}

export interface IBaseError {
  error: string
  status: number
}

export interface IPaginationQueryParams {
  pageSize: number
  pageIndex: number
  sortBy: string
}

export type TType = (key: string) => string

export enum CANCELLATION_FEE_TABS {
  PERCENT = "PERCENT",
  FIXED = "FIXED",
}

export enum BOOKING_FEE_TABS {
  PERCENT = "PERCENT",
  FIXED = "FIXED",
}

export enum LANGUAGE_FEE_TABS {
  GEORGIA = "GEORGIA",
  ENGLISH = "ENGLISH",
  RUSSIA = "RUSSIA",
}

export enum TRANSACTION_STATUSES {
  SUCCESS = "Succeed",
  FAIL = "FAIL",
  PENDING = "PENDING",
}

export enum REFUND_TABS {
  PARTLY = "PARTLY",
  FULLY = "FULLY",
}

export interface IFormMainProperties<T> {
  values: T
  errors: FormikErrors<T>
  touched: FormikTouched<T>
  handleChange: (e: React.ChangeEvent<any>) => void
  handleBlur: (e: any) => void
  setValues: FormikHelpers<T>["setValues"]
}

export interface IBaseQueryParams {
  sortBy: string
  pageSize: number
  pageIndex: number
}
